<template>
  <layout-page-menu
    :heroTitle="$t('Views.Settings.InvoiceSettings.Main_Title')"
    :heroSubTitle="''"
    heroAdditionalClass="mb-6"
    class="section"
  >
    <template slot="pageHeroQuickAction">
      <a
        class="has-icon is-hidden-mobile"
        id="id_button_guide"
        :href="$t('Views.Settings.InvoiceSettings.Guide_Link')"
        target="_blank"
      >
        <span class="icon">
          <font-awesome-icon :icon="['fas', 'info-circle']" />
        </span>
        <span class="text">{{ $t('General.Guide') }}</span>
      </a>
    </template>
    <template slot="pageMenu">
      <ui-page-menu :menuItems="menuItems"></ui-page-menu>
    </template>
    <template slot="pageContent">
      <div class="container">
        <component v-bind:is="menuItems[selectedMenuItems[2]].Component" />
      </div>
    </template>
  </layout-page-menu>
</template>

<script>
import { mapState } from "vuex";

import InvoiceSettings from "@/components/Settings/Invoice/InvoiceSettings.vue"
import InvoiceTexts from "@/components/Settings/Invoice/InvoiceTexts.vue"
import LedgerNumbers from "@/components/Invoices/LedgerNumbers.vue";

export default {
  components: {
    InvoiceSettings,
    InvoiceTexts,
    LedgerNumbers
  },

  data() {
    return {
    };
  },

  computed: {
    ...mapState("menuStore", ["selectedMenuItems"]),

    menuItems() {
      return [
        {
          Name: this.$t('Views.Settings.InvoiceSettings.Menu_BasicSettings'),
          Component: "InvoiceSettings"
        },
        {
          Name: this.$t('Views.Settings.InvoiceSettings.Menu_TextSettings'),
          Component: "InvoiceTexts"
        },
        {
          Name: this.$t('Views.Settings.InvoiceSettings.Menu_LedgerNumbers'),
          Component: "LedgerNumbers"
        }
      ];
    }
  },

  methods: {

  }
};
</script>
